// frontend/src/hooks/useMyOrders.ts
import { useQuery } from '@tanstack/react-query'
import { useAccount } from 'wagmi'
import { apiClient } from '../lib/api'

export function useMyOrders() {
  const { address } = useAccount()
  return useQuery({
    queryKey: ['p2p', 'orders', 'me', address?.toLowerCase()],
    queryFn: () => apiClient.getMyP2POrders(address!),
    enabled: !!address,
    refetchInterval: 10_000,
  })
}
